import React, { useEffect, useState, useRef } from "react";
import { 
    Card, Grid, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, 
    MenuItem, Select, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, Switch, 
    Autocomplete, TextField, List, ListItem, ListItemButton, ListItemIcon, Checkbox, ListItemText, 
    CircularProgress, Paper, Chip, Tooltip, Menu, Popover
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { get, post, postNoResponse } from "utils/WebService";
import MDSnackbar from "components/MDSnackbar";
import { useMaterialUIController } from "context";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";

export default function RegrasFilaCreateEdit({ recordId, closeCreateEdit }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [nome, setNome] = useState("");
    const [ativo, setAtivo] = useState(true);
    const [itens, setItens] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [pessoaOptions, setPessoaOptions] = useState([]);
    const [marcacaoOptions, setMarcacaoOptions] = useState([]);
    
    const [equipeOptions, setEquipeOptions] = useState([]);
    const [myEquipes, setMyEquipes] = useState([]);
    const [selectedEquipe, setSelectedEquipe] = useState("");
    const [pendingEquipe, setPendingEquipe] = useState(null);
    const [equipeAlertOpen, setEquipeAlertOpen] = useState(false);
    const [saveConfirmOpen, setSaveConfirmOpen] = useState(false);

    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");

    const [editingItemIndex, setEditingItemIndex] = useState(null);
    const [draggedItemIndex, setDraggedItemIndex] = useState(null);
    const dragItemRef = useRef(null);

    const [clienteModoGeral, setClienteModoGeral] = useState(false);
    const [globalPessoasIds, setGlobalPessoasIds] = useState([]);
    const [globalPessoasNomes, setGlobalPessoasNomes] = useState([]);
    const [globalPessoasInverter, setGlobalPessoasInverter] = useState(false);

    const [casosModalOpen, setCasosModalOpen] = useState(false);
    const [casosList, setCasosList] = useState([]);
    const [loadingCasos, setLoadingCasos] = useState(false);

    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [devedorDetail, setDevedorDetail] = useState(null);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [loadingRecalcular, setLoadingRecalcular] = useState(false);

    const [addFilterAnchorEl, setAddFilterAnchorEl] = useState(null);

    const normalizeItens = (rawItens) => {
        if (!Array.isArray(rawItens)) return [];
        return rawItens.map((it, idx) => ({
            id: it.id || it.cvId,
            statusFichaIds: Array.isArray(it.statusFichaIds) 
                ? it.statusFichaIds 
                : (it.ccStatusFichasIds ? it.ccStatusFichasIds.split(",") : []),
            statusInverter: it.statusInverter ?? it.cbStatusInverter ?? false,
            pessoasIds: Array.isArray(it.pessoasIds) 
                ? it.pessoasIds 
                : (it.ccPessoasIds ? it.ccPessoasIds.split(",") : []),
            pessoasNomes: Array.isArray(it.pessoasNomes) ? it.pessoasNomes : [],
            pessoasInverter: it.pessoasInverter ?? it.cbPessoasInverter ?? false,
            marcacoesIds: Array.isArray(it.marcacoesIds)
                ? it.marcacoesIds
                : (it.ccMarcacoesIds ? it.ccMarcacoesIds.split(",") : []),
            marcacoesInverter: it.marcacoesInverter ?? it.cbMarcacoesInverter ?? false,
            regraAgendamento: it.regraAgendamento ?? it.cvRegraAgendamento ?? null,
            saldoMin: it.saldoMin ?? it.cnSaldoMin ?? "",
            saldoMax: it.saldoMax ?? it.cnSaldoMax ?? "",
            tipoAcordo: it.tipoAcordo ?? "todos",
            pesoOrdem: it.pesoOrdem ?? it.cvPesoOrdem ?? (idx + 1),
            totalCasos: it.totalCasos ?? 0,
            activeFilters: it.activeFilters || determineActiveFilters(it)
        }));
    };

    const determineActiveFilters = (item) => {
        const filters = [];
        if (item.statusFichaIds && item.statusFichaIds.length > 0) filters.push("status");
        if (item.regraAgendamento !== null && item.regraAgendamento !== undefined) filters.push("agendamento");
        if ((item.saldoMin !== "" && item.saldoMin !== null) || (item.saldoMax !== "" && item.saldoMax !== null)) filters.push("saldo");
        if (item.tipoAcordo && item.tipoAcordo !== "todos") filters.push("tipoAcordo");
        if (item.marcacoesIds && item.marcacoesIds.length > 0) filters.push("marcacao");
        if (!clienteModoGeral && item.pessoasIds && item.pessoasIds.length > 0) filters.push("cliente");
        if (filters.length === 0) filters.push("status");
        return filters;
    };

    const applyRuleData = (data) => {
        if (!data) return;
        setNome(data.nome || data.ccNome || "");
        setAtivo(data.ativo ?? data.cvIndAtivo ?? true);
        setSelectedEquipe(data.equipeId || "");
        const loadedItens = normalizeItens(data.itens || data.tbRegraFilaItems || []);
        setItens(loadedItens);

        const resolvedClients = [];
        loadedItens.forEach(it => {
            const pIds = it.pessoasIds || [];
            const pNomes = it.pessoasNomes || [];
            pIds.forEach((id, idx) => {
                if (id && pNomes[idx]) {
                    resolvedClients.push({ id, nomeComum: pNomes[idx], nomeCompleto: pNomes[idx] });
                }
            });
        });
        if (resolvedClients.length > 0) {
            setPessoaOptions(prev => {
                const map = new Map(prev.map(p => [p.id, p]));
                resolvedClients.forEach(c => {
                    if (!map.has(c.id) || !map.get(c.id)?.nomeComum) {
                        map.set(c.id, { ...(map.get(c.id) || {}), ...c });
                    }
                });
                return Array.from(map.values());
            });
        }

        const uniquePessoaIds = Array.from(new Set(loadedItens.flatMap(it => it.pessoasIds || [])));
        uniquePessoaIds.forEach(pId => {
            if (pId) {
                get(`/pessoa/by-id/${pId}`).then(res => {
                    if (res && (res.nomeComum || res.nomeCompleto || res.ccNomeComum || res.ccNomeCompleto)) {
                        const name = res.nomeComum || res.nomeCompleto || res.ccNomeComum || res.ccNomeCompleto;
                        setPessoaOptions(prev => {
                            const map = new Map(prev.map(p => [p.id, p]));
                            map.set(pId, { id: pId, nomeComum: name, nomeCompleto: name });
                            return Array.from(map.values());
                        });
                    }
                }).catch(() => {});
            }
        });

        if (loadedItens.length > 0) {
            const firstPessoas = loadedItens[0].pessoasIds || [];
            const firstNomes = loadedItens[0].pessoasNomes || [];
            const firstInverter = loadedItens[0].pessoasInverter || false;
            const allSame = loadedItens.every(it => {
                const currentPessoas = it.pessoasIds || [];
                if ((it.pessoasInverter || false) !== firstInverter) return false;
                if (currentPessoas.length !== firstPessoas.length) return false;
                return currentPessoas.every(id => firstPessoas.includes(id));
            });

            if (allSame && firstPessoas.length > 0) {
                setClienteModoGeral(true);
                setGlobalPessoasIds(firstPessoas);
                setGlobalPessoasNomes(firstNomes);
                setGlobalPessoasInverter(firstInverter);
            } else {
                setClienteModoGeral(false);
                setGlobalPessoasIds([]);
                setGlobalPessoasNomes([]);
                setGlobalPessoasInverter(false);
            }
        }
    };

    const getNumericId = (val) => {
        if (!val) return null;
        if (typeof val === "object") return val.id || val.cvId || null;
        const parsed = parseInt(val, 10);
        return isNaN(parsed) ? null : parsed;
    };

    useEffect(() => {
        get("/status-ficha/list-all").then((res) => {
            setStatusOptions(res.list || res.data || (Array.isArray(res) ? res : []));
        });

        get("/pessoa/list-all").then((res) => {
            setPessoaOptions(res.list || res.data || (Array.isArray(res) ? res : []));
        });

        get("/marcacoes").then((res) => {
            const list = res?.list || res?.data || (Array.isArray(res) ? res : []);
            setMarcacaoOptions(list);
        }).catch(() => {});

        get("/equipe/list-all").then((res) => {
            const list = res?.list || res?.data || (Array.isArray(res) ? res : []);
            setEquipeOptions(list);
        });

        get("/equipe/minhas-equipes").then((res) => {
            const list = res?.list || res?.data || (Array.isArray(res) ? res : []);
            setMyEquipes(list);
            if (!recordId && list.length > 0) {
                setSelectedEquipe(list[0].id);
            }
        });

        if (recordId) {
            if (typeof recordId === "object" && recordId !== null) {
                applyRuleData(recordId);
            }
            const cleanId = getNumericId(recordId);
            if (cleanId) {
                get(`/regra-fila/by-id/${cleanId}`).then((res) => {
                    if (res) applyRuleData(res);
                }).catch((err) => {
                    console.error("Erro ao carregar detalhes da regra:", err);
                    setSbMessage("Erro ao carregar os dados completos da regra.");
                    setErrorSB(true);
                });
            }
        } else {
            setNome("");
            setAtivo(true);
            setItens([{
                statusFichaIds: [],
                statusInverter: false,
                pessoasIds: [],
                pessoasInverter: false,
                marcacoesIds: [],
                marcacoesInverter: false,
                regraAgendamento: null,
                saldoMin: "",
                saldoMax: "",
                tipoAcordo: "todos",
                pesoOrdem: 1,
                totalCasos: 0,
                activeFilters: ["status"]
            }]);
            setSelectedEquipe("");
            setEditingItemIndex(0);
        }
    }, [recordId]);

    const sanitizeItemPayload = (item, idx) => {
        const parsedId = getNumericId(item?.id);
        const hasActiveFilters = Array.isArray(item?.activeFilters);

        const statusIds = (!hasActiveFilters || item.activeFilters.includes("status")) && Array.isArray(item?.statusFichaIds)
            ? item.statusFichaIds.map(s => String(typeof s === "object" ? (s.id || s.cvId || s) : s))
            : [];
        const pIds = clienteModoGeral
            ? (globalPessoasIds || []).map(p => String(typeof p === "object" ? (p.id || p.cvId || p) : p))
            : (((!hasActiveFilters || item.activeFilters.includes("cliente")) && Array.isArray(item?.pessoasIds)) ? item.pessoasIds.map(p => String(typeof p === "object" ? (p.id || p.cvId || p) : p)) : []);
        const mIds = (!hasActiveFilters || item.activeFilters.includes("marcacao")) && Array.isArray(item?.marcacoesIds)
            ? item.marcacoesIds.map(m => String(typeof m === "object" ? (m.id || m.cvId || m) : m))
            : [];

        let age = null;
        if ((!hasActiveFilters || item.activeFilters.includes("agendamento")) && item?.regraAgendamento !== null && item?.regraAgendamento !== undefined && item?.regraAgendamento !== "") {
            const pAge = parseInt(item.regraAgendamento, 10);
            if (!isNaN(pAge)) age = pAge;
        }

        let sMin = null;
        if ((!hasActiveFilters || item.activeFilters.includes("saldo")) && item?.saldoMin !== null && item?.saldoMin !== undefined && item?.saldoMin !== "") {
            const pMin = parseFloat(item.saldoMin);
            if (!isNaN(pMin)) sMin = pMin;
        }

        let sMax = null;
        if ((!hasActiveFilters || item.activeFilters.includes("saldo")) && item?.saldoMax !== null && item?.saldoMax !== undefined && item?.saldoMax !== "") {
            const pMax = parseFloat(item.saldoMax);
            if (!isNaN(pMax)) sMax = pMax;
        }

        let pOrdem = (idx !== undefined ? idx + 1 : 1);
        if (item?.pesoOrdem !== null && item?.pesoOrdem !== undefined && item?.pesoOrdem !== "") {
            const pOrd = parseInt(item.pesoOrdem, 10);
            if (!isNaN(pOrd)) pOrdem = pOrd;
        }

        return {
            id: parsedId,
            equipeId: selectedEquipe || null,
            statusFichaIds: statusIds,
            statusInverter: !!item?.statusInverter,
            pessoasIds: pIds,
            pessoasInverter: clienteModoGeral ? !!globalPessoasInverter : !!item?.pessoasInverter,
            marcacoesIds: mIds,
            marcacoesInverter: !!item?.marcacoesInverter,
            regraAgendamento: age,
            saldoMin: sMin,
            saldoMax: sMax,
            pesoOrdem: pOrdem
        };
    };

    const handleEquipeChange = (newVal) => {
        setSelectedEquipe(newVal);
    };

    const handleSave = () => {
        if (!nome || !nome.trim()) {
            setSbMessage("Informe o nome da regra.");
            setErrorSB(true);
            return;
        }
        executeSave();
    };

    const executeSave = () => {
        setSaveConfirmOpen(false);
        const payload = {
            id: getNumericId(recordId),
            nome,
            ativo,
            equipeId: selectedEquipe || null,
            itens: itens.map((item, idx) => sanitizeItemPayload(item, idx))
        };

        postNoResponse("/regra-fila/save", payload).then(() => {
            setSbMessage("Regra salva com sucesso!");
            setSuccessSB(true);
            setTimeout(() => {
                closeCreateEdit();
            }, 1000);
        }).catch((err) => {
            const errorMsg = err?.response?.data?.message || err?.data?.message || err?.message || "Erro ao salvar regra.";
            setSbMessage(errorMsg);
            setErrorSB(true);
        });
    };

    const handleAddItem = () => {
        const newItemIndex = itens.length;
        setItens([...itens, {
            statusFichaIds: [],
            statusInverter: false,
            pessoasIds: clienteModoGeral ? [...globalPessoasIds] : [],
            pessoasInverter: clienteModoGeral ? globalPessoasInverter : false,
            marcacoesIds: [],
            marcacoesInverter: false,
            regraAgendamento: null,
            saldoMin: "",
            saldoMax: "",
            tipoAcordo: "todos",
            pesoOrdem: newItemIndex + 1,
            totalCasos: 0,
            activeFilters: ["status"]
        }]);
        setEditingItemIndex(newItemIndex);
    };

    const handleMovePriority = (index, direction) => {
        const newItens = [...itens];
        const targetIndex = direction === "up" ? index - 1 : index + 1;
        if (targetIndex < 0 || targetIndex >= newItens.length) return;
        const temp = newItens[index];
        newItens[index] = newItens[targetIndex];
        newItens[targetIndex] = temp;

        newItens.forEach((it, i) => {
            it.pesoOrdem = i + 1;
        });

        setItens(newItens);
        if (editingItemIndex === index) setEditingItemIndex(targetIndex);
        else if (editingItemIndex === targetIndex) setEditingItemIndex(index);
    };

    const handleDragStart = (e, index) => {
        dragItemRef.current = index;
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/plain", index.toString());
        setTimeout(() => {
            setDraggedItemIndex(index);
        }, 10);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        const row = e.currentTarget.closest("tr");
        if (row) {
            row.style.outline = "2px dashed #00b0ff";
            row.style.outlineOffset = "-2px";
            row.style.backgroundColor = darkMode ? "rgba(0, 176, 255, 0.18)" : "rgba(33, 150, 243, 0.12)";
        }
    };

    const handleDragLeave = (e) => {
        const row = e.currentTarget.closest("tr");
        if (row && !row.contains(e.relatedTarget)) {
            row.style.outline = "";
            row.style.outlineOffset = "";
            row.style.backgroundColor = "";
        }
    };

    const handleDrop = (e, targetIndex) => {
        e.preventDefault();
        e.stopPropagation();

        document.querySelectorAll(".regra-fila-row").forEach(r => {
            r.style.outline = "";
            r.style.outlineOffset = "";
            r.style.backgroundColor = "";
        });

        const rawData = e.dataTransfer.getData("text/plain");
        let sourceIndex = dragItemRef.current;
        if (sourceIndex === null || sourceIndex === undefined) {
            if (rawData !== "") {
                sourceIndex = parseInt(rawData, 10);
            }
        }

        if (sourceIndex === null || sourceIndex === undefined || isNaN(sourceIndex)) {
            setDraggedItemIndex(null);
            return;
        }

        if (sourceIndex === targetIndex) {
            dragItemRef.current = null;
            setDraggedItemIndex(null);
            return;
        }

        setItens(prevItens => {
            const newItens = [...prevItens];
            const [movedItem] = newItens.splice(sourceIndex, 1);
            newItens.splice(targetIndex, 0, movedItem);

            newItens.forEach((it, i) => {
                it.pesoOrdem = i + 1;
            });
            return newItens;
        });

        if (editingItemIndex === sourceIndex) {
            setEditingItemIndex(targetIndex);
        } else if (editingItemIndex !== null) {
            if (sourceIndex < editingItemIndex && targetIndex >= editingItemIndex) {
                setEditingItemIndex(editingItemIndex - 1);
            } else if (sourceIndex > editingItemIndex && targetIndex <= editingItemIndex) {
                setEditingItemIndex(editingItemIndex + 1);
            }
        }

        dragItemRef.current = null;
        setDraggedItemIndex(null);
    };

    const handleDragEnd = () => {
        document.querySelectorAll(".regra-fila-row").forEach(r => {
            r.style.outline = "";
            r.style.outlineOffset = "";
            r.style.backgroundColor = "";
        });
        dragItemRef.current = null;
        setDraggedItemIndex(null);
    };

    const handleDuplicateItem = (index) => {
        const target = itens[index];
        if (!target) return;
        const newItem = {
            ...JSON.parse(JSON.stringify(target)),
            id: null,
            pesoOrdem: itens.length + 1,
            totalCasos: 0
        };
        const newItens = [...itens, newItem];
        setItens(newItens);
        setEditingItemIndex(newItens.length - 1);
    };

    const handleRemoveItem = (index) => {
        const newItens = itens.filter((_, i) => i !== index);
        newItens.forEach((it, i) => {
            it.pesoOrdem = i + 1;
        });
        setItens(newItens);
        if (editingItemIndex === index) setEditingItemIndex(null);
        else if (editingItemIndex > index) setEditingItemIndex(editingItemIndex - 1);
    };

    const handleItemChange = (index, field, value) => {
        const newItens = [...itens];
        newItens[index][field] = value;
        if (field === "pessoasIds" && Array.isArray(value)) {
            newItens[index].pessoasNomes = value.map(id => {
                const opt = pessoaOptions.find(p => p.id === id);
                return opt ? (opt.nomeComum || opt.nomeCompleto) : "";
            });
        }
        setItens(newItens);
    };

    const handleAddFilterToItem = (filterKey) => {
        if (editingItemIndex === null || editingItemIndex === undefined) return;
        const newItens = [...itens];
        const currentItem = newItens[editingItemIndex];
        const active = currentItem.activeFilters || [];
        if (!active.includes(filterKey)) {
            currentItem.activeFilters = [...active, filterKey];
            setItens(newItens);
        }
        setAddFilterAnchorEl(null);
    };

    const handleRemoveFilterFromItem = (index, filterKey) => {
        const newItens = [...itens];
        const currentItem = newItens[index];
        currentItem.activeFilters = (currentItem.activeFilters || []).filter(k => k !== filterKey);
        
        if (filterKey === "status") currentItem.statusFichaIds = [];
        if (filterKey === "agendamento") currentItem.regraAgendamento = null;
        if (filterKey === "saldo") { currentItem.saldoMin = ""; currentItem.saldoMax = ""; }
        if (filterKey === "tipoAcordo") currentItem.tipoAcordo = "todos";
        if (filterKey === "marcacao") currentItem.marcacoesIds = [];
        if (filterKey === "cliente") currentItem.pessoasIds = [];

        setItens(newItens);
    };

    const handleRecalcularContadores = () => {
        setLoadingRecalcular(true);
        const dto = {
            id: getNumericId(recordId),
            nome: nome || "Nova Regra",
            ativo: ativo !== undefined ? ativo : true,
            equipeId: selectedEquipe || null,
            itens: itens.map((item, idx) => sanitizeItemPayload(item, idx))
        };

        post("/regra-fila/recalcular-contadores", dto).then((res) => {
            const updatedItens = Array.isArray(res) ? res : (res?.data || res?.list || []);
            if (updatedItens.length > 0) {
                setItens(prevItens => prevItens.map((item, idx) => {
                    const match = updatedItens[idx];
                    return {
                        ...item,
                        totalCasos: match && match.totalCasos != null ? match.totalCasos : 0
                    };
                }));
            }
            setSbMessage("Contadores recalculados com sucesso!");
            setSuccessSB(true);
            setLoadingRecalcular(false);
        }).catch((err) => {
            const errorMsg = err?.response?.data?.message || err?.data?.message || err?.message || "Erro ao recalcular contadores.";
            setSbMessage(errorMsg);
            setErrorSB(true);
            setLoadingRecalcular(false);
        });
    };

    const handleOpenCasosModal = (index) => {
        const item = itens[index];
        if (!item) return;
        setCasosModalOpen(true);
        setLoadingCasos(true);
        setCasosList([]);
        const payloadItem = sanitizeItemPayload(item, index);
        post("/regra-fila/listar-devedores-item", payloadItem).then((res) => {
            const list = Array.isArray(res) ? res : (res?.data || res?.list || []);
            setCasosList(list);
            setLoadingCasos(false);
        }).catch((err) => {
            const errorMsg = err?.response?.data?.message || err?.data?.message || err?.message || "Erro ao buscar devedores do item.";
            setSbMessage(errorMsg);
            setErrorSB(true);
            setLoadingCasos(false);
        });
    };

    const handleOpenDetailModal = (devId) => {
        if (!devId) return;
        setDetailModalOpen(true);
        setLoadingDetail(true);
        setDevedorDetail(null);
        get(`/devedor/by-id/${devId}`).then((res) => {
            setDevedorDetail(res || null);
            setLoadingDetail(false);
        }).catch(() => {
            setLoadingDetail(false);
        });
    };

    const totalCasosGeral = itens.reduce((acc, item) => acc + (item.totalCasos || 0), 0);

    const getStatusTitleSummary = (statusIds) => {
        if (!statusIds || statusIds.length === 0) return "Todos os Status";
        const names = statusIds.map(id => {
            const st = statusOptions.find(opt => opt.id === id || opt.cvId === id);
            return st ? (st.ccNome || st.id) : id;
        });
        return names.join(", ");
    };

    const getAgendamentoLabel = (val) => {
        if (val === null || val === undefined || val === "") return "Ignorar";
        if (val === 1 || val === "1") return "Atrasado / Hoje";
        if (val === 2 || val === "2") return "Futuro";
        if (val === 3 || val === "3") return "Sem Agendamento";
        if (val === 4 || val === "4") return "Apenas Hoje";
        return "Ignorar";
    };

    const getPessoasSummary = (pessoasIds, fallbackNomes = []) => {
        if (clienteModoGeral && globalPessoasIds.length > 0) {
            const names = globalPessoasIds.map((id, idx) => {
                const p = pessoaOptions.find(opt => opt.id === id);
                return p ? (p.nomeComum || p.nomeCompleto) : (globalPessoasNomes[idx] || "Cliente");
            });
            return names.join(", ");
        }
        if (!pessoasIds || pessoasIds.length === 0) return "Todos os Clientes";
        const names = pessoasIds.map((id, idx) => {
            const p = pessoaOptions.find(opt => opt.id === id);
            return p ? (p.nomeComum || p.nomeCompleto) : (fallbackNomes[idx] || id);
        });
        return names.join(", ");
    };

    const formatAgendamentoDate = (dateVal) => {
        if (!dateVal) return "Sem agendamento";
        try {
            const d = new Date(dateVal);
            if (isNaN(d.getTime())) return "Sem agendamento";
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            if (hours === "00" && minutes === "00") {
                return `${day}/${month}/${year}`;
            }
            return `${day}/${month}/${year} ${hours}:${minutes}`;
        } catch (e) {
            return "Sem agendamento";
        }
    };

    const formatCurrency = (val) => {
        if (val === null || val === undefined) return "R$ 0,00";
        const num = Number(val);
        if (isNaN(num)) return "R$ 0,00";
        return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    return (
        <MDBox id="regra-fila-editor-container" sx={{ color: darkMode ? "#ffffff" : "inherit" }}>
            {/* Top Bar Header */}
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDBox display="flex" alignItems="center">
                    <IconButton onClick={closeCreateEdit} sx={{ p: 0, pr: 1.5, color: darkMode ? "#ffffff" : "inherit" }}>
                        <Icon fontSize="medium">arrow_back</Icon>
                    </IconButton>
                    <MDBox>
                        <MDTypography variant="h5" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                            {recordId ? "Editar Regra" : "Nova Regra"}
                        </MDTypography>
                        <MDTypography variant="caption" color={darkMode ? "white" : "text"} opacity={0.8}>
                            Configure as regras de acordo para a equipe e os clientes desejados.
                        </MDTypography>
                    </MDBox>
                </MDBox>
            </MDBox>

            {/* Main Header Form Card */}
            <Card variant="outlined" sx={{ p: 2.5, mb: 3, background: darkMode ? "#4B4F5C" : "#ffffff", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "12px" }}>
                <Grid container spacing={2.5} alignItems="center">
                    <Grid item xs={12} md={4}>
                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} display="block" mb={0.5}>
                            Nome da Regra *
                        </MDTypography>
                        <MDInput 
                            fullWidth 
                            size="small"
                            placeholder="Nome da Regra..." 
                            value={nome} 
                            onChange={(e) => setNome(e.target.value)} 
                            required 
                            sx={{
                                "& .MuiInputBase-root": {
                                    backgroundColor: darkMode ? "#3A3E4A" : "#ffffff",
                                    color: darkMode ? "#ffffff" : "inherit",
                                    borderColor: darkMode ? "#5D616D" : "#ccc"
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} display="block" mb={0.5}>
                            Equipe *
                        </MDTypography>
                        <FormControl fullWidth size="small">
                            <Select
                                value={selectedEquipe || ""}
                                onChange={(e) => handleEquipeChange(e.target.value)}
                                displayEmpty
                                sx={{
                                    height: "40px",
                                    backgroundColor: darkMode ? "#3A3E4A" : "#ffffff",
                                    color: darkMode ? "#ffffff !important" : "inherit",
                                    "& .MuiSelect-select": { color: darkMode ? "#ffffff !important" : "inherit" },
                                    "& .MuiSvgIcon-root": { color: darkMode ? "#ffffff !important" : "inherit" }
                                }}
                            >
                                {(!myEquipes || myEquipes.length === 0) && (
                                    <MenuItem value="">
                                        <em>Todas / Geral (Sem Equipe)</em>
                                    </MenuItem>
                                )}
                                {(myEquipes && myEquipes.length > 0 ? myEquipes : equipeOptions).map((eq) => (
                                    <MenuItem key={eq.id} value={eq.id}>
                                        {eq.nome}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} display="flex" alignItems="center" pt={2.5}>
                        <Switch checked={ativo} onChange={(e) => setAtivo(e.target.checked)} color="info" />
                        <MDBox ml={1}>
                            <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                Status da Regra: {ativo ? "Ativa" : "Inativa"}
                            </MDTypography>
                            <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                A regra estará disponível para uso no sistema.
                            </MDTypography>
                        </MDBox>
                    </Grid>
                </Grid>

                {/* Global Client Selection Bar */}
                <MDBox mt={2.5} pt={2} sx={{ borderTop: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #eee" }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={4} display="flex" alignItems="center">
                            <Switch 
                                checked={clienteModoGeral} 
                                onChange={(e) => {
                                    const isGeral = e.target.checked;
                                    setClienteModoGeral(isGeral);
                                    if (isGeral) {
                                        const firstPessoas = itens[0]?.pessoasIds || globalPessoasIds || [];
                                        const firstInverter = itens[0]?.pessoasInverter || globalPessoasInverter || false;
                                        setGlobalPessoasIds(firstPessoas);
                                        setGlobalPessoasInverter(firstInverter);
                                    }
                                }} 
                                color="info" 
                            />
                            <MDBox ml={1}>
                                <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                    Aplicar para todos os clientes
                                </MDTypography>
                                <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                    Um único cliente selecionado no topo será aplicado a todas as regras abaixo.
                                </MDTypography>
                            </MDBox>
                        </Grid>

                        {clienteModoGeral && (
                            <>
                                <Grid item xs={12} md={5}>
                                    <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} display="block" mb={0.5}>
                                        Cliente(s) Geral (opcional)
                                    </MDTypography>
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        options={pessoaOptions}
                                        getOptionLabel={(opt) => opt.nomeComum || opt.nomeCompleto || opt.id || ""}
                                        value={pessoaOptions.filter(p => globalPessoasIds.includes(p.id))}
                                        onChange={(_, newValue) => {
                                            const newIds = newValue.map(v => v.id);
                                            const newNomes = newValue.map(v => v.nomeComum || v.nomeCompleto);
                                            setGlobalPessoasIds(newIds);
                                            setGlobalPessoasNomes(newNomes);
                                            setItens(prev => prev.map(item => ({ ...item, pessoasIds: newIds, pessoasNomes: newNomes })));
                                        }}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    size="small"
                                                    label={option.nomeComum || option.nomeCompleto}
                                                    {...getTagProps({ index })}
                                                    key={option.id}
                                                    color="info"
                                                    variant="outlined"
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField 
                                                {...params} 
                                                placeholder="Selecione os clientes..." 
                                                variant="outlined"
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        backgroundColor: darkMode ? "#3A3E4A" : "#ffffff",
                                                        color: darkMode ? "#ffffff" : "inherit"
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3} display="flex" alignItems="center">
                                    <Switch 
                                        checked={globalPessoasInverter} 
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setGlobalPessoasInverter(checked);
                                            setItens(prev => prev.map(item => ({ ...item, pessoasInverter: checked })));
                                        }} 
                                        color="warning" 
                                    />
                                    <MDBox ml={1}>
                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                            Inverter Regra (NÃO é este)
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </MDBox>
            </Card>

            {/* Rules / Items Section Header */}
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDBox display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="bold" color={darkMode ? "white" : "dark"} mr={2}>
                        Regras
                    </MDTypography>
                    <Chip 
                        label={`TOTAL DE CASOS: ${totalCasosGeral}`} 
                        color="info" 
                        size="medium" 
                        sx={{ fontWeight: "bold", fontSize: "0.8rem", px: 1 }} 
                    />
                </MDBox>
                <MDBox display="flex" gap={1.5}>
                    <MDButton 
                        variant="outlined" 
                        color="info" 
                        size="small" 
                        onClick={handleRecalcularContadores}
                        disabled={loadingRecalcular}
                        sx={{
                            fontWeight: "bold",
                            borderRadius: "8px",
                            transition: "all 0.2s ease-in-out",
                            ...(darkMode ? {
                                color: "#00b0ff",
                                borderColor: "#00b0ff",
                                backgroundColor: "rgba(0, 176, 255, 0.12)",
                                "&:hover": {
                                    color: "#ffffff",
                                    borderColor: "#00b0ff",
                                    backgroundColor: "#00b0ff",
                                    boxShadow: "0 0 10px rgba(0, 176, 255, 0.5)",
                                },
                                "&:disabled": {
                                    color: "rgba(255, 255, 255, 0.6) !important",
                                    borderColor: "rgba(255, 255, 255, 0.3) !important",
                                    backgroundColor: "rgba(255, 255, 255, 0.05) !important"
                                }
                            } : {
                                "&:hover": {
                                    backgroundColor: "rgba(26, 115, 232, 0.08)"
                                }
                            })
                        }}
                    >
                        {loadingRecalcular ? (
                            <CircularProgress size={16} sx={{ mr: 0.7, color: darkMode ? "#00b0ff" : "inherit" }} />
                        ) : (
                            <Icon sx={{ mr: 0.5 }}>refresh</Icon>
                        )}
                        Recalcular Contadores
                    </MDButton>
                    <MDButton 
                        variant="gradient" 
                        color="info" 
                        size="small" 
                        onClick={handleAddItem}
                        sx={{
                            fontWeight: "bold",
                            borderRadius: "8px",
                            px: 2,
                            boxShadow: darkMode ? "0 4px 12px rgba(0, 176, 255, 0.3)" : undefined,
                            "&:hover": {
                                transform: "translateY(-1px)",
                                boxShadow: darkMode ? "0 6px 16px rgba(0, 176, 255, 0.45)" : undefined,
                            }
                        }}
                    >
                        <Icon sx={{ mr: 0.5 }}>add</Icon>
                        Adicionar Regra
                    </MDButton>
                </MDBox>
            </MDBox>

            {/* Rules Items Table Container */}
            <TableContainer component={Paper} variant="outlined" sx={{ background: darkMode ? "#4B4F5C" : "#ffffff", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "12px", overflow: "hidden" }}>
                <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                    <TableHead sx={{ display: "table-header-group", backgroundColor: darkMode ? "#383B46" : "#f5f5f5" }}>
                        <TableRow>
                            <DataTableHeadCell width="3%" sorted={false}>#</DataTableHeadCell>
                            <DataTableHeadCell width="12%" sorted={false}>Prioridade</DataTableHeadCell>
                            <DataTableHeadCell width="22%" sorted={false}>Regra</DataTableHeadCell>
                            <DataTableHeadCell width="12%" sorted={false}>Cliente(s)</DataTableHeadCell>
                            <DataTableHeadCell width="37%" sorted={false}>Resumo dos Filtros</DataTableHeadCell>
                            <DataTableHeadCell width="6%" align="center" sorted={false}>Casos</DataTableHeadCell>
                            <DataTableHeadCell width="8%" align="center" sorted={false}>Ações</DataTableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itens.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center" sx={{ py: 3, color: darkMode ? "#ffffff" : "inherit" }}>
                                    Nenhum item configurado. Clique em "Adicionar Regra" para criar um filtro.
                                </TableCell>
                            </TableRow>
                        ) : (
                            itens.map((item, index) => {
                                const isEditing = editingItemIndex === index;
                                const statusCount = item.statusFichaIds?.length || 0;
                                const marcacaoCount = item.marcacoesIds?.length || 0;
                                const hasAgendamento = item.regraAgendamento !== null && item.regraAgendamento !== undefined && item.regraAgendamento !== "";
                                const hasSaldo = (item.saldoMin !== "" && item.saldoMin !== null && item.saldoMin !== undefined) || (item.saldoMax !== "" && item.saldoMax !== null && item.saldoMax !== undefined);
                                let extraFiltersCount = 0;
                                if (item.tipoAcordo && item.tipoAcordo !== "todos") extraFiltersCount++;
                                if (!clienteModoGeral && item.pessoasIds && item.pessoasIds.length > 0) extraFiltersCount++;

                                return (
                                    <React.Fragment key={index}>
                                        <TableRow 
                                            key={item.id ? `item-${item.id}` : `idx-${index}`}
                                            className="regra-fila-row"
                                            onDragOver={handleDragOver}
                                            onDragEnter={handleDragEnter}
                                            onDragLeave={handleDragLeave}
                                            onDrop={(e) => handleDrop(e, index)}
                                            sx={{ 
                                                verticalAlign: "middle", 
                                                backgroundColor: isEditing 
                                                    ? (darkMode ? "#3A3E4A" : "#f0f7ff") 
                                                    : "transparent",
                                                opacity: draggedItemIndex === index ? 0.35 : 1,
                                                transition: "opacity 0.2s ease"
                                            }}
                                        >
                                            <TableCell sx={{ width: "3%", py: 1.5, px: 1, color: darkMode ? "#ffffff" : "inherit", fontWeight: "bold", verticalAlign: "middle" }}>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell 
                                                sx={{ width: "12%", py: 1.5, px: 1, verticalAlign: "middle" }}
                                                onDragOver={handleDragOver}
                                                onDrop={(e) => handleDrop(e, index)}
                                            >
                                                <Tooltip title="Arraste para reordenar a prioridade" arrow placement="top">
                                                    <MDBox 
                                                        draggable
                                                        onDragStart={(e) => handleDragStart(e, index)}
                                                        onDragEnd={handleDragEnd}
                                                        display="inline-flex" 
                                                        alignItems="center" 
                                                        justifyContent="center"
                                                        gap={0.6}
                                                        sx={{ 
                                                            cursor: "grab",
                                                            "&:active": { cursor: "grabbing" },
                                                            border: "1px solid", 
                                                            borderColor: darkMode ? "rgba(255, 255, 255, 0.25)" : "#ccc", 
                                                            borderRadius: "8px", 
                                                            px: 1.4, 
                                                            py: 0.45,
                                                            bgcolor: darkMode ? "#3A3E4A" : "#f8f9fa",
                                                            transition: "all 0.2s ease-in-out",
                                                            userSelect: "none",
                                                            "&:hover": {
                                                                borderColor: "#00b0ff",
                                                                bgcolor: darkMode ? "rgba(0, 176, 255, 0.18)" : "rgba(0, 176, 255, 0.08)",
                                                                transform: "translateY(-1px)",
                                                                boxShadow: darkMode ? "0 2px 8px rgba(0, 176, 255, 0.25)" : "0 2px 6px rgba(0,0,0,0.1)"
                                                            }
                                                        }}
                                                    >
                                                        <Icon sx={{ fontSize: "1.2rem !important", color: darkMode ? "#00b0ff" : "#1976d2", pointerEvents: "none" }}>
                                                            drag_indicator
                                                        </Icon>
                                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "dark"} sx={{ fontSize: "0.875rem", pointerEvents: "none" }}>
                                                            {index + 1}
                                                        </MDTypography>
                                                    </MDBox>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell sx={{ width: "22%", py: 1.5, px: 1, cursor: "pointer", verticalAlign: "middle" }} onClick={() => setEditingItemIndex(isEditing ? null : index)}>
                                                <MDBox display="flex" alignItems="center" gap={1}>
                                                    <Icon sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}>
                                                        {isEditing ? "keyboard_arrow_down" : "keyboard_arrow_right"}
                                                    </Icon>
                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"} noWrap sx={{ maxWidth: "180px" }}>
                                                        {getStatusTitleSummary(item.statusFichaIds)}
                                                    </MDTypography>
                                                </MDBox>
                                            </TableCell>
                                            <TableCell sx={{ width: "12%", py: 1.5, px: 1, verticalAlign: "middle" }}>
                                                <Chip 
                                                    size="small"
                                                    label={getPessoasSummary(item.pessoasIds, item.pessoasNomes)} 
                                                    variant="outlined" 
                                                    color="info" 
                                                    sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? "rgba(255, 255, 255, 0.3) !important" : undefined }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ width: "37%", py: 1.5, px: 1, verticalAlign: "middle" }}>
                                                <MDBox display="flex" flexWrap="wrap" gap={0.5}>
                                                    <Chip 
                                                        size="small" 
                                                        label={statusCount > 0 ? `Status: ${statusCount} selecionado(s)` : "Status: Todos"} 
                                                        color="info" 
                                                        variant="outlined"
                                                        sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined }}
                                                    />
                                                    <Chip 
                                                        size="small" 
                                                        label={`Agendamento: ${getAgendamentoLabel(item.regraAgendamento)}`} 
                                                        color="info" 
                                                        variant="outlined"
                                                        sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined }}
                                                    />
                                                    <Chip 
                                                        size="small" 
                                                        label={hasSaldo ? `Saldo: ${item.saldoMin || 0} - ${item.saldoMax || 'Max'}` : "Saldo: Não informado"} 
                                                        color="info" 
                                                        variant="outlined"
                                                        sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined }}
                                                    />
                                                    {marcacaoCount > 0 && (
                                                        <Chip 
                                                            size="small" 
                                                            label={`Marcação: ${marcacaoCount} selecionada(s)`} 
                                                            color="info" 
                                                            variant="outlined"
                                                            sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined }}
                                                        />
                                                    )}
                                                    {extraFiltersCount > 0 && (
                                                        <Chip 
                                                            size="small" 
                                                            label={`+ ${extraFiltersCount} filtro(s)`} 
                                                            color="info" 
                                                        />
                                                    )}
                                                </MDBox>
                                            </TableCell>
                                            <TableCell align="center" sx={{ width: "6%", py: 1.5, px: 1, verticalAlign: "middle" }}>
                                                <Tooltip title="Clique para ver lista de casos do item">
                                                    <Chip 
                                                        label={item.totalCasos || 0} 
                                                        color="info" 
                                                        size="medium"
                                                        onClick={() => handleOpenCasosModal(index)}
                                                        sx={{ fontWeight: "bold", cursor: "pointer", borderRadius: "16px" }}
                                                    />
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="center" sx={{ width: "8%", py: 1.5, px: 1, verticalAlign: "middle" }}>
                                                <MDBox display="flex" justifyContent="center" gap={0.5}>
                                                    <Tooltip title="Copiar / Duplicar Regra">
                                                        <IconButton size="small" onClick={() => handleDuplicateItem(index)} sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}>
                                                            <Icon fontSize="small">content_copy</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Editar Regra">
                                                        <IconButton size="small" onClick={() => setEditingItemIndex(isEditing ? null : index)} sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}>
                                                            <Icon fontSize="small">edit</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Excluir Regra">
                                                        <IconButton size="small" onClick={() => handleRemoveItem(index)} color="error">
                                                            <Icon fontSize="small">delete</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                </MDBox>
                                            </TableCell>
                                        </TableRow>

                                        {/* Expanded Rule Filter Editor */}
                                        {isEditing && (
                                            <TableRow>
                                                <TableCell colSpan={7} sx={{ p: 2, backgroundColor: darkMode ? "#3A3E4A" : "#f8fafd" }}>
                                                    <Card variant="outlined" sx={{ p: 2.5, background: darkMode ? "#424550" : "#ffffff", borderColor: darkMode ? "#00b0ff" : "#2196f3", borderRadius: "10px" }}>
                                                        {/* Header of Item Editor */}
                                                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2} pb={1.5} sx={{ borderBottom: darkMode ? "1px solid #2D323E" : "1px solid #eee" }}>
                                                            <MDBox display="flex" alignItems="center">
                                                                <Icon sx={{ color: "#00b0ff", mr: 1 }}>filter_alt</Icon>
                                                                <MDBox>
                                                                    <MDTypography variant="h6" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                                        Filtros da Regra
                                                                    </MDTypography>
                                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} opacity={0.8}>
                                                                        Defina os critérios para esta regra. Os casos serão considerados quando atenderem a todos os filtros configurados.
                                                                    </MDTypography>
                                                                </MDBox>
                                                            </MDBox>
                                                            <MDButton 
                                                                variant="outlined" 
                                                                color="info" 
                                                                size="small"
                                                                onClick={(e) => setAddFilterAnchorEl(e.currentTarget)}
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    borderRadius: "8px",
                                                                    ...(darkMode ? {
                                                                        color: "#00b0ff",
                                                                        borderColor: "#00b0ff",
                                                                        backgroundColor: "rgba(0, 176, 255, 0.12)",
                                                                        "&:hover": {
                                                                            color: "#ffffff",
                                                                            borderColor: "#00b0ff",
                                                                            backgroundColor: "#00b0ff",
                                                                            boxShadow: "0 0 10px rgba(0, 176, 255, 0.5)",
                                                                        }
                                                                    } : {})
                                                                }}
                                                            >
                                                                <Icon sx={{ mr: 0.5 }}>add</Icon>
                                                                Adicionar Filtro
                                                            </MDButton>
                                                        </MDBox>

                                                        {/* List of Active Filter Cards */}
                                                        <Grid container spacing={2}>
                                                            {/* Filter: Status da Ficha */}
                                                            {(item.activeFilters || []).includes("status") && (
                                                                <Grid item xs={12}>
                                                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                                                                        <Grid container spacing={2} alignItems="center">
                                                                            <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                                                <MDBox p={1} borderRadius="50%" bg="info" color="white" display="flex" mr={1.5}>
                                                                                    <Icon fontSize="small">description</Icon>
                                                                                </MDBox>
                                                                                <MDBox>
                                                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                                                        Status da Ficha
                                                                                    </MDTypography>
                                                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                                                                        Selecione os status que serão considerados.
                                                                                    </MDTypography>
                                                                                </MDBox>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={8}>
                                                                                <Autocomplete
                                                                                    multiple
                                                                                    size="small"
                                                                                    options={statusOptions}
                                                                                    getOptionLabel={(opt) => opt.ccNome || opt.id || ""}
                                                                                    value={statusOptions.filter(st => item.statusFichaIds?.includes(st.id))}
                                                                                    onChange={(_, newValue) => {
                                                                                        handleItemChange(index, "statusFichaIds", newValue.map(v => v.id));
                                                                                    }}
                                                                                    renderTags={(value, getTagProps) =>
                                                                                        value.map((option, tagIndex) => (
                                                                                            <Chip
                                                                                                size="small"
                                                                                                label={option.ccNome}
                                                                                                {...getTagProps({ index: tagIndex })}
                                                                                                key={option.id}
                                                                                                color="info"
                                                                                            />
                                                                                        ))
                                                                                    }
                                                                                    renderInput={(params) => (
                                                                                        <TextField 
                                                                                            {...params} 
                                                                                            placeholder="Selecione os status..." 
                                                                                            variant="outlined" 
                                                                                            sx={{
                                                                                                "& .MuiOutlinedInput-root": {
                                                                                                    backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                                                                    color: darkMode ? "#ffffff" : "inherit"
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={1} display="flex" justifyContent="flex-end">
                                                                                <IconButton color="error" onClick={() => handleRemoveFilterFromItem(index, "status")}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Card>
                                                                </Grid>
                                                            )}

                                                            {/* Filter: Agendamento */}
                                                            {(item.activeFilters || []).includes("agendamento") && (
                                                                <Grid item xs={12}>
                                                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                                                                        <Grid container spacing={2} alignItems="center">
                                                                            <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                                                <MDBox p={1} borderRadius="50%" bg="info" color="white" display="flex" mr={1.5}>
                                                                                    <Icon fontSize="small">event</Icon>
                                                                                </MDBox>
                                                                                <MDBox>
                                                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                                                        Agendamento
                                                                                    </MDTypography>
                                                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                                                                        Filtre pelos status de agendamento.
                                                                                    </MDTypography>
                                                                                </MDBox>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={8}>
                                                                                <FormControl fullWidth size="small">
                                                                                    <Select
                                                                                        value={item.regraAgendamento !== null && item.regraAgendamento !== undefined ? item.regraAgendamento : ""}
                                                                                        onChange={(e) => handleItemChange(index, "regraAgendamento", e.target.value === "" ? null : parseInt(e.target.value, 10))}
                                                                                        displayEmpty
                                                                                        sx={{
                                                                                            height: "40px",
                                                                                            backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                                                            color: darkMode ? "#ffffff !important" : "inherit"
                                                                                        }}
                                                                                    >
                                                                                        <MenuItem value="">Ignorar</MenuItem>
                                                                                        <MenuItem value={1}>Atrasado / Hoje (&lt;= Hoje)</MenuItem>
                                                                                        <MenuItem value={2}>Futuro (&gt; Hoje)</MenuItem>
                                                                                        <MenuItem value={3}>Sem Agendamento</MenuItem>
                                                                                        <MenuItem value={4}>Apenas Hoje (= Hoje)</MenuItem>
                                                                                    </Select>
                                                                                </FormControl>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={1} display="flex" justifyContent="flex-end">
                                                                                <IconButton color="error" onClick={() => handleRemoveFilterFromItem(index, "agendamento")}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Card>
                                                                </Grid>
                                                            )}

                                                            {/* Filter: Saldo */}
                                                            {(item.activeFilters || []).includes("saldo") && (
                                                                <Grid item xs={12}>
                                                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                                                                        <Grid container spacing={2} alignItems="center">
                                                                            <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                                                <MDBox p={1} borderRadius="50%" bg="info" color="white" display="flex" mr={1.5}>
                                                                                    <Icon fontSize="small">attach_money</Icon>
                                                                                </MDBox>
                                                                                <MDBox>
                                                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                                                        Saldo
                                                                                    </MDTypography>
                                                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                                                                        Defina a faixa de saldo.
                                                                                    </MDTypography>
                                                                                </MDBox>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={4}>
                                                                                <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" mb={0.5}>
                                                                                    Valor mínimo (R$)
                                                                                </MDTypography>
                                                                                <MDInput 
                                                                                    fullWidth
                                                                                    size="small"
                                                                                    type="number"
                                                                                    placeholder="Ex.: 1.000,00"
                                                                                    value={item.saldoMin || ""}
                                                                                    onChange={(e) => handleItemChange(index, "saldoMin", e.target.value)}
                                                                                    sx={{
                                                                                        "& .MuiInputBase-root": {
                                                                                            backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                                                            color: darkMode ? "#ffffff" : "inherit"
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={4}>
                                                                                <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" mb={0.5}>
                                                                                    Valor máximo (R$)
                                                                                </MDTypography>
                                                                                <MDInput 
                                                                                    fullWidth
                                                                                    size="small"
                                                                                    type="number"
                                                                                    placeholder="Ex.: 10.000,00"
                                                                                    value={item.saldoMax || ""}
                                                                                    onChange={(e) => handleItemChange(index, "saldoMax", e.target.value)}
                                                                                    sx={{
                                                                                        "& .MuiInputBase-root": {
                                                                                            backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                                                            color: darkMode ? "#ffffff" : "inherit"
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={1} display="flex" justifyContent="flex-end">
                                                                                <IconButton color="error" onClick={() => handleRemoveFilterFromItem(index, "saldo")}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Card>
                                                                </Grid>
                                                            )}

                                                            {/* Filter: Tipo de Acordo */}
                                                            {(item.activeFilters || []).includes("tipoAcordo") && (
                                                                <Grid item xs={12}>
                                                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                                                                        <Grid container spacing={2} alignItems="center">
                                                                            <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                                                <MDBox p={1} borderRadius="50%" bg="info" color="white" display="flex" mr={1.5}>
                                                                                    <Icon fontSize="small">filter_list</Icon>
                                                                                </MDBox>
                                                                                <MDBox>
                                                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                                                        Tipo de Acordo
                                                                                    </MDTypography>
                                                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                                                                        Selecione o tipo de acordo.
                                                                                    </MDTypography>
                                                                                </MDBox>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={8}>
                                                                                <FormControl fullWidth size="small">
                                                                                    <Select
                                                                                        value={item.tipoAcordo || "todos"}
                                                                                        onChange={(e) => handleItemChange(index, "tipoAcordo", e.target.value)}
                                                                                        sx={{
                                                                                            height: "40px",
                                                                                            backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                                                            color: darkMode ? "#ffffff !important" : "inherit"
                                                                                        }}
                                                                                    >
                                                                                        <MenuItem value="todos">Todos</MenuItem>
                                                                                        <MenuItem value="a_vista">À Vista</MenuItem>
                                                                                        <MenuItem value="parcelado">Parcelado</MenuItem>
                                                                                        <MenuItem value="renegociado">Renegociado</MenuItem>
                                                                                    </Select>
                                                                                </FormControl>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={1} display="flex" justifyContent="flex-end">
                                                                                <IconButton color="error" onClick={() => handleRemoveFilterFromItem(index, "tipoAcordo")}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Card>
                                                                </Grid>
                                                            )}

                                                            {/* Filter: Marcação Especial */}
                                                            {(item.activeFilters || []).includes("marcacao") && (
                                                                <Grid item xs={12}>
                                                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                                                                        <Grid container spacing={2} alignItems="center">
                                                                            <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                                                <MDBox p={1} borderRadius="50%" bg="info" color="white" display="flex" mr={1.5}>
                                                                                    <Icon fontSize="small">local_offer</Icon>
                                                                                </MDBox>
                                                                                <MDBox>
                                                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                                                        Marcação
                                                                                    </MDTypography>
                                                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                                                                        Selecione as marcações especiais consideradas.
                                                                                    </MDTypography>
                                                                                </MDBox>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={8}>
                                                                                <Autocomplete
                                                                                    multiple
                                                                                    size="small"
                                                                                    options={marcacaoOptions}
                                                                                    getOptionLabel={(opt) => opt.ccNome || opt.nome || opt.id || ""}
                                                                                    value={marcacaoOptions.filter(m => item.marcacoesIds?.includes(m.id || m.cvId))}
                                                                                    onChange={(_, newValue) => {
                                                                                        handleItemChange(index, "marcacoesIds", newValue.map(v => v.id || v.cvId));
                                                                                    }}
                                                                                    renderTags={(value, getTagProps) =>
                                                                                        value.map((option, tagIndex) => (
                                                                                            <Chip
                                                                                                size="small"
                                                                                                label={option.ccNome || option.nome}
                                                                                                {...getTagProps({ index: tagIndex })}
                                                                                                key={option.id || option.cvId}
                                                                                                color="info"
                                                                                            />
                                                                                        ))
                                                                                    }
                                                                                    renderInput={(params) => (
                                                                                        <TextField 
                                                                                            {...params} 
                                                                                            placeholder="Selecione as marcações..." 
                                                                                            variant="outlined" 
                                                                                            sx={{
                                                                                                "& .MuiOutlinedInput-root": {
                                                                                                    backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                                                                    color: darkMode ? "#ffffff" : "inherit"
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={1} display="flex" justifyContent="flex-end">
                                                                                <IconButton color="error" onClick={() => handleRemoveFilterFromItem(index, "marcacao")}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Card>
                                                                </Grid>
                                                            )}

                                                            {/* Filter: Cliente Individual (se não estiver em modo geral) */}
                                                            {!clienteModoGeral && (item.activeFilters || []).includes("cliente") && (
                                                                <Grid item xs={12}>
                                                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                                                                        <Grid container spacing={2} alignItems="center">
                                                                            <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                                                <MDBox p={1} borderRadius="50%" bg="info" color="white" display="flex" mr={1.5}>
                                                                                    <Icon fontSize="small">person</Icon>
                                                                                </MDBox>
                                                                                <MDBox>
                                                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                                                        Cliente(s)
                                                                                    </MDTypography>
                                                                                    <MDTypography variant="caption" color={darkMode ? "white" : "text"} display="block" opacity={0.7}>
                                                                                        Filtre por clientes específicos desta regra.
                                                                                    </MDTypography>
                                                                                </MDBox>
                                                                            </Grid>
                                                                            <Grid item xs={12} md={8}>
                                                                                <Autocomplete
                                                                                    multiple
                                                                                    size="small"
                                                                                    options={pessoaOptions}
                                                                                    getOptionLabel={(opt) => opt.nomeComum || opt.nomeCompleto || opt.id || ""}
                                                                                    value={pessoaOptions.filter(p => item.pessoasIds?.includes(p.id))}
                                                                                    onChange={(_, newValue) => {
                                                                                        handleItemChange(index, "pessoasIds", newValue.map(v => v.id));
                                                                                    }}
                                                                                    renderTags={(value, getTagProps) =>
                                                                                        value.map((option, tagIndex) => (
                                                                                            <Chip
                                                                                                size="small"
                                                                                                label={option.nomeComum || option.nomeCompleto}
                                                                                                {...getTagProps({ index: tagIndex })}
                                                                                                key={option.id}
                                                                                                color="info"
                                                                                            />
                                                                                        ))
                                                                                    }
                                                                                    renderInput={(params) => (
                                                                                        <TextField 
                                                                                            {...params} 
                                                                                            placeholder="Selecione os clientes..." 
                                                                                            variant="outlined" 
                                                                                            sx={{
                                                                                                "& .MuiOutlinedInput-root": {
                                                                                                    backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                                                                                                    color: darkMode ? "#ffffff" : "inherit"
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={1} display="flex" justifyContent="flex-end">
                                                                                <IconButton color="error" onClick={() => handleRemoveFilterFromItem(index, "cliente")}>
                                                                                    <Icon>delete</Icon>
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Card>
                                                                </Grid>
                                                            )}
                                                        </Grid>

                                                        {/* Footer Actions of Expanded Editor */}
                                                        <MDBox display="flex" justifyContent="flex-end" alignItems="center" mt={3} pt={2} sx={{ borderTop: darkMode ? "1px solid #2D323E" : "1px solid #eee" }}>
                                                            <MDBox display="flex" gap={1.5}>
                                                                <MDButton 
                                                                    variant="outlined" 
                                                                    color={darkMode ? "white" : "secondary"} 
                                                                    size="small"
                                                                    onClick={() => setEditingItemIndex(null)}
                                                                    sx={{
                                                                        fontWeight: "bold",
                                                                        borderRadius: "8px",
                                                                        ...(darkMode && {
                                                                            color: "#ffffff",
                                                                            borderColor: "rgba(255, 255, 255, 0.4)",
                                                                            "&:hover": {
                                                                                borderColor: "#ffffff",
                                                                                backgroundColor: "rgba(255, 255, 255, 0.1)"
                                                                            }
                                                                        })
                                                                    }}
                                                                >
                                                                    Cancelar
                                                                </MDButton>
                                                                <MDButton 
                                                                    variant="gradient" 
                                                                    color="info" 
                                                                    size="small"
                                                                    onClick={() => setEditingItemIndex(null)}
                                                                    sx={{
                                                                        fontWeight: "bold",
                                                                        borderRadius: "8px",
                                                                        boxShadow: darkMode ? "0 4px 12px rgba(0, 176, 255, 0.3)" : undefined
                                                                    }}
                                                                >
                                                                    Salvar Filtro da Regra
                                                                </MDButton>
                                                            </MDBox>
                                                        </MDBox>
                                                    </Card>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </React.Fragment>
                                );
                            })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Menu Popover for Adding Filters */}
            <Menu
                anchorEl={addFilterAnchorEl}
                open={Boolean(addFilterAnchorEl)}
                onClose={() => setAddFilterAnchorEl(null)}
                PaperProps={{
                    sx: {
                        backgroundColor: darkMode ? "#2A2D35" : "#ffffff",
                        color: darkMode ? "#ffffff" : "inherit"
                    }
                }}
            >
                <MenuItem onClick={() => handleAddFilterToItem("status")}>
                    <ListItemIcon sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}><Icon fontSize="small">description</Icon></ListItemIcon>
                    <ListItemText primary="Status da Ficha" />
                </MenuItem>
                <MenuItem onClick={() => handleAddFilterToItem("agendamento")}>
                    <ListItemIcon sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}><Icon fontSize="small">event</Icon></ListItemIcon>
                    <ListItemText primary="Agendamento" />
                </MenuItem>
                <MenuItem onClick={() => handleAddFilterToItem("saldo")}>
                    <ListItemIcon sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}><Icon fontSize="small">attach_money</Icon></ListItemIcon>
                    <ListItemText primary="Saldo" />
                </MenuItem>
                <MenuItem onClick={() => handleAddFilterToItem("tipoAcordo")}>
                    <ListItemIcon sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}><Icon fontSize="small">filter_list</Icon></ListItemIcon>
                    <ListItemText primary="Tipo de Acordo" />
                </MenuItem>
                <MenuItem onClick={() => handleAddFilterToItem("marcacao")}>
                    <ListItemIcon sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}><Icon fontSize="small">local_offer</Icon></ListItemIcon>
                    <ListItemText primary="Marcação" />
                </MenuItem>
                {!clienteModoGeral && (
                    <MenuItem onClick={() => handleAddFilterToItem("cliente")}>
                        <ListItemIcon sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }}><Icon fontSize="small">person</Icon></ListItemIcon>
                        <ListItemText primary="Cliente(s)" />
                    </MenuItem>
                )}
            </Menu>

            {/* Bottom Global Action Buttons */}
            <MDBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                <MDButton 
                    variant="outlined" 
                    color={darkMode ? "white" : "secondary"} 
                    onClick={closeCreateEdit}
                    sx={{
                        fontWeight: "bold",
                        borderRadius: "8px",
                        ...(darkMode && {
                            color: "#ffffff",
                            borderColor: "rgba(255, 255, 255, 0.4)",
                            "&:hover": {
                                borderColor: "#ffffff",
                                backgroundColor: "rgba(255, 255, 255, 0.1)"
                            }
                        })
                    }}
                >
                    Cancelar
                </MDButton>
                <MDButton 
                    variant="gradient" 
                    color="info" 
                    onClick={handleSave}
                    sx={{
                        fontWeight: "bold",
                        borderRadius: "8px",
                        px: 3,
                        boxShadow: darkMode ? "0 4px 14px rgba(0, 176, 255, 0.35)" : undefined,
                        "&:hover": {
                            transform: "translateY(-1px)",
                            boxShadow: darkMode ? "0 6px 18px rgba(0, 176, 255, 0.5)" : undefined,
                        }
                    }}
                >
                    Salvar Regra
                </MDButton>
            </MDBox>

            {/* Modals & Dialogs */}
            {/* Modal de Casos / Devedores */}
            <Dialog 
                open={casosModalOpen} 
                onClose={() => setCasosModalOpen(false)} 
                maxWidth="md" 
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                        color: darkMode ? "#ffffff" : "inherit",
                        borderRadius: "16px",
                        backgroundImage: "none"
                    }
                }}
            >
                <DialogTitle sx={{ color: darkMode ? "#ffffff" : "inherit", fontWeight: "bold", pb: 1 }}>
                    Fichas / Devedores Contabilizados no Item
                </DialogTitle>
                <DialogContent dividers sx={{ borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                    {loadingCasos ? (
                        <MDBox display="flex" justifyContent="center" p={3}>
                            <CircularProgress size={30} color="info" />
                        </MDBox>
                    ) : casosList.length === 0 ? (
                        <MDTypography variant="button" color={darkMode ? "white" : "text"}>
                            Nenhum caso encontrado para este item.
                        </MDTypography>
                    ) : (
                        <TableContainer component={Paper} variant="outlined" sx={{ background: darkMode ? "#4B4F5C" : "#ffffff", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "12px", overflow: "hidden" }}>
                            <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                                <TableHead sx={{ display: "table-header-group", backgroundColor: darkMode ? "#383B46" : "#f5f5f5" }}>
                                    <TableRow>
                                        <DataTableHeadCell width="16%" sorted={false}>Código Devedor</DataTableHeadCell>
                                        <DataTableHeadCell width="34%" sorted={false}>Nome / Razão Social</DataTableHeadCell>
                                        <DataTableHeadCell width="18%" sorted={false}>CPF / CNPJ</DataTableHeadCell>
                                        <DataTableHeadCell width="24%" sorted={false}>Status da Ficha</DataTableHeadCell>
                                        <DataTableHeadCell width="8%" align="center" sorted={false}>Ação</DataTableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {casosList.map((dev, idx) => (
                                        <TableRow key={idx}>
                                            <TableCell sx={{ width: "16%", py: 1.5, px: 1, color: darkMode ? "#ffffff" : "inherit", verticalAlign: "middle" }}>
                                                <MDTypography variant="caption" color={darkMode ? "white" : "text"} fontWeight="bold">
                                                    {dev.cvId ?? dev.devedorCvId ?? dev.codigo ?? dev.devedorCodigo ?? dev.devedorId ?? dev.id}
                                                </MDTypography>
                                            </TableCell>
                                            <TableCell sx={{ width: "34%", py: 1.5, px: 1, color: darkMode ? "#ffffff" : "inherit", verticalAlign: "middle" }}>
                                                <MDTypography variant="caption" color={darkMode ? "white" : "text"} fontWeight="bold">
                                                    {dev.ccNome || dev.nome || dev.devedorNome || "-"}
                                                </MDTypography>
                                            </TableCell>
                                            <TableCell sx={{ width: "18%", py: 1.5, px: 1, color: darkMode ? "#ffffff" : "inherit", verticalAlign: "middle" }}>
                                                <MDTypography variant="caption" color={darkMode ? "white" : "text"}>
                                                    {dev.ccCpfCnpj || dev.cpfCnpj || dev.devedorCpfCnpj || "-"}
                                                </MDTypography>
                                            </TableCell>
                                            <TableCell sx={{ width: "24%", py: 1.5, px: 1, color: darkMode ? "#ffffff" : "inherit", verticalAlign: "middle" }}>
                                                <Chip 
                                                    size="small" 
                                                    label={dev.statusFicha || dev.statusNome || dev.statusFichaNome || "Sem Status"} 
                                                    color="info" 
                                                    variant="outlined" 
                                                    sx={{ 
                                                        color: darkMode ? "#ffffff !important" : undefined, 
                                                        borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined 
                                                    }} 
                                                />
                                            </TableCell>
                                            <TableCell align="center" sx={{ width: "8%", py: 1.5, px: 1, verticalAlign: "middle" }}>
                                                <IconButton size="small" sx={{ color: darkMode ? "#00b0ff" : "#1976d2" }} onClick={() => handleOpenDetailModal(dev.id || dev.devedorId)}>
                                                    <Icon fontSize="small">visibility</Icon>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <MDButton 
                        variant="outlined" 
                        onClick={() => setCasosModalOpen(false)} 
                        color={darkMode ? "white" : "secondary"}
                        size="small"
                        sx={{
                            fontWeight: "bold",
                            borderRadius: "8px",
                            ...(darkMode && {
                                color: "#ffffff",
                                borderColor: "rgba(255, 255, 255, 0.4)",
                                "&:hover": {
                                    borderColor: "#ffffff",
                                    backgroundColor: "rgba(255, 255, 255, 0.1)"
                                }
                            })
                        }}
                    >
                        Fechar
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* Modal de Detalhes / Resumo do Devedor */}
            <Dialog 
                open={detailModalOpen} 
                onClose={() => setDetailModalOpen(false)} 
                maxWidth="md" 
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                        color: darkMode ? "#ffffff" : "inherit",
                        borderRadius: "16px",
                        backgroundImage: "none"
                    }
                }}
            >
                <DialogTitle sx={{ color: darkMode ? "#ffffff" : "inherit", fontWeight: "bold", pb: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <MDTypography variant="h5" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                        Resumo do Devedor (#{devedorDetail?.unencryptedId || devedorDetail?.cvId || devedorDetail?.codigo || devedorDetail?.id || "-"})
                    </MDTypography>
                    <IconButton size="small" onClick={() => setDetailModalOpen(false)} sx={{ color: darkMode ? "#ffffff" : "inherit" }}>
                        <Icon fontSize="small">close</Icon>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0" }}>
                    {loadingDetail ? (
                        <MDBox display="flex" justifyContent="center" p={3}>
                            <CircularProgress size={30} color="info" />
                        </MDBox>
                    ) : !devedorDetail ? (
                        <MDTypography variant="button" color={darkMode ? "white" : "text"}>
                            Não foi possível carregar os detalhes.
                        </MDTypography>
                    ) : (
                        <MDBox p={1}>
                            {/* Top Cards Grid */}
                            <Grid container spacing={2} mb={3}>
                                <Grid item xs={12} sm={6}>
                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "10px" }}>
                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} opacity={0.8} display="block" mb={0.5}>
                                            Nome do Devedor
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                            {devedorDetail.ccNome || devedorDetail.nome || "-"}
                                        </MDTypography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "10px" }}>
                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} opacity={0.8} display="block" mb={0.5}>
                                            CPF / CNPJ
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                            {devedorDetail.ccDocumento || devedorDetail.documento || devedorDetail.cpfCnpj || "-"}
                                        </MDTypography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "10px" }}>
                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} opacity={0.8} display="block" mb={0.5}>
                                            Cliente
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                            {devedorDetail.nomeCliente || devedorDetail.nomeClienteFantasia || devedorDetail.tbPessoa?.ccNomeComum || devedorDetail.tbPessoa?.ccNomeCompleto || devedorDetail.cliente || "-"}
                                        </MDTypography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "10px" }}>
                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} opacity={0.8} display="block" mb={0.5}>
                                            Responsável
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                            {devedorDetail.nomeUsuario || devedorDetail.responsavel || devedorDetail.nomeUsuarioDono || (devedorDetail.fichas && devedorDetail.fichas.length > 0 ? (devedorDetail.fichas[0].nomeUsuarioDono || devedorDetail.fichas[0].nomeUsuario) : null) || "-"}
                                        </MDTypography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "10px" }}>
                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} opacity={0.8} display="block" mb={0.5}>
                                            Status da Ficha
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" sx={{ color: darkMode ? "#64b5f6" : "#1976d2" }}>
                                            {devedorDetail.statusFichaNome || devedorDetail.statusFicha || (devedorDetail.fichas && devedorDetail.fichas.length > 0 ? devedorDetail.fichas[0].nomeStatusFicha : null) || "Sem status"}
                                        </MDTypography>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Card variant="outlined" sx={{ p: 2, background: darkMode ? "#3A3E4A" : "#fafafa", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "10px" }}>
                                        <MDTypography variant="caption" fontWeight="bold" color={darkMode ? "white" : "text"} opacity={0.8} display="block" mb={0.5}>
                                            Agendamento
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                            {formatAgendamentoDate(devedorDetail.dataAgendamento || devedorDetail.cdAgendamento || devedorDetail.agendamento)}
                                        </MDTypography>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* Contratos e Saldos Section */}
                            <MDTypography variant="h6" fontWeight="bold" color={darkMode ? "white" : "dark"} mb={1.5}>
                                Contratos e Saldos
                            </MDTypography>

                            <TableContainer component={Paper} variant="outlined" sx={{ background: darkMode ? "#3A3E4A" : "#ffffff", borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : "#e0e0e0", borderRadius: "10px", overflow: "hidden" }}>
                                <Table size="small" sx={{ width: "100%", tableLayout: "fixed" }}>
                                    <TableHead sx={{ display: "table-header-group", p: 0, backgroundColor: darkMode ? "#2D323E" : "#f5f5f5" }}>
                                        <TableRow sx={{ display: "table-row" }}>
                                            <TableCell component="th" sx={{ display: "table-cell", width: "45%", py: 1.5, px: 2, color: darkMode ? "#ffffff" : "text.secondary", opacity: 0.8, fontSize: "0.75rem", fontWeight: "bold", textTransform: "uppercase", borderBottom: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #e0e0e0" }}>
                                                Contrato / Título
                                            </TableCell>
                                            <TableCell component="th" sx={{ display: "table-cell", width: "25%", py: 1.5, px: 1, color: darkMode ? "#ffffff" : "text.secondary", opacity: 0.8, fontSize: "0.75rem", fontWeight: "bold", textTransform: "uppercase", borderBottom: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #e0e0e0" }}>
                                                Situação
                                            </TableCell>
                                            <TableCell component="th" align="right" sx={{ display: "table-cell", width: "30%", py: 1.5, px: 2, color: darkMode ? "#ffffff" : "text.secondary", opacity: 0.8, fontSize: "0.75rem", fontWeight: "bold", textTransform: "uppercase", borderBottom: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #e0e0e0" }}>
                                                Saldo (R$)
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ display: "table-row-group" }}>
                                        {(!devedorDetail.contratos || devedorDetail.contratos.length === 0) ? (
                                            <TableRow sx={{ display: "table-row" }}>
                                                <TableCell colSpan={3} align="center" sx={{ display: "table-cell", py: 2, color: darkMode ? "#ffffff" : "inherit" }}>
                                                    Nenhum contrato cadastrado.
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            devedorDetail.contratos.map((c, i) => (
                                                <TableRow key={i} sx={{ display: "table-row" }}>
                                                    <TableCell sx={{ display: "table-cell", width: "45%", py: 1.5, px: 2, color: darkMode ? "#ffffff" : "inherit", verticalAlign: "middle" }}>
                                                        <MDTypography variant="button" color={darkMode ? "white" : "dark"} fontWeight="medium">
                                                            {c.titulo || c.ccTitulo || c.parcela || "-"}
                                                        </MDTypography>
                                                    </TableCell>
                                                    <TableCell sx={{ display: "table-cell", width: "25%", py: 1.5, px: 1, verticalAlign: "middle" }}>
                                                        <MDTypography variant="caption" fontWeight="bold" sx={{ color: (c.situacao === 1 || c.cvSituacao === 1 || c.situacao === undefined) ? "#66bb6a" : (darkMode ? "#ffffff" : "inherit") }}>
                                                            {(c.situacao === 1 || c.cvSituacao === 1 || c.situacao === undefined) ? "Ativo" : "Inativo"}
                                                        </MDTypography>
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ display: "table-cell", width: "30%", py: 1.5, px: 2, color: darkMode ? "#ffffff" : "inherit", verticalAlign: "middle" }}>
                                                        <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                            {formatCurrency(c.saldo !== undefined && c.saldo !== null ? c.saldo : c.cvSaldo)}
                                                        </MDTypography>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                        {/* Total Row */}
                                        {devedorDetail.contratos && devedorDetail.contratos.length > 0 && (
                                            <TableRow sx={{ display: "table-row", backgroundColor: darkMode ? "#2D323E" : "#f8f9fa" }}>
                                                <TableCell colSpan={2} sx={{ display: "table-cell", py: 1.5, px: 2, color: darkMode ? "#ffffff" : "inherit", verticalAlign: "middle" }}>
                                                    <MDTypography variant="button" fontWeight="bold" color={darkMode ? "white" : "dark"}>
                                                        Saldo Total Ativo:
                                                    </MDTypography>
                                                </TableCell>
                                                <TableCell align="right" sx={{ display: "table-cell", py: 1.5, px: 2, verticalAlign: "middle" }}>
                                                    <MDTypography variant="button" fontWeight="bold" sx={{ color: "#66bb6a" }}>
                                                        {formatCurrency(
                                                            devedorDetail.contratos.reduce((acc, c) => acc + Number((c.situacao === 1 || c.cvSituacao === 1 || c.situacao === undefined) ? (c.saldo || c.cvSaldo || 0) : 0), 0)
                                                        )}
                                                    </MDTypography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MDBox>
                    )}
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <MDButton 
                        variant="outlined" 
                        onClick={() => setDetailModalOpen(false)} 
                        color={darkMode ? "white" : "secondary"}
                        size="small"
                        sx={{
                            fontWeight: "bold",
                            borderRadius: "8px",
                            ...(darkMode && {
                                color: "#ffffff",
                                borderColor: "rgba(255, 255, 255, 0.4)",
                                "&:hover": {
                                    borderColor: "#ffffff",
                                    backgroundColor: "rgba(255, 255, 255, 0.1)"
                                }
                            })
                        }}
                    >
                        Fechar
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* Snackbars */}
            <MDSnackbar
                color="success"
                icon="check"
                title="Sucesso"
                dateTime=""
                content={sbMessage}
                open={successSB}
                onClose={() => setSuccessSB(false)}
                close={() => setSuccessSB(false)}
            />
            <MDSnackbar
                color="error"
                icon="warning"
                title="Atenção"
                dateTime=""
                content={sbMessage}
                open={errorSB}
                onClose={() => setErrorSB(false)}
                close={() => setErrorSB(false)}
            />
        </MDBox>
    );
}
